/**
 * Service for managing input blocking state.
 * UI elements (dialogue, inventory, menus) register themselves as blocking sources.
 * Movement input is blocked when any source is active.
 */
export class InputBlockingService {
  private blockingSources = new Set<string>();

  private onBlockedCallback: (() => void) | null = null;

  /** Add a blocking source (e.g., 'dialogue', 'inventory') */
  block(source: string): void {
    const wasEmpty = this.blockingSources.size === 0;
    this.blockingSources.add(source);
    // Notify that blocking just became active
    if (wasEmpty && this.onBlockedCallback) {
      this.onBlockedCallback();
    }
  }

  /** Remove a blocking source */
  unblock(source: string): void {
    this.blockingSources.delete(source);
  }

  /** Check if any source is blocking input */
  isMovementBlocked(): boolean {
    return this.blockingSources.size > 0;
  }

  /** Set callback for when blocking becomes active (to clear held inputs) */
  setOnBlockedCallback(callback: () => void): void {
    this.onBlockedCallback = callback;
  }
}
